import { stringify } from 'qs';
import {request} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let ServiceOtherRegisterController = {
    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/service-other-register/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    edit: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/service-other-register/edit`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    listStudentInService: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/service-other-register/list-student-in-service`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    detail: (productId, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/service-other-register/detail/${productId}`,
            method: 'GET'
        }, callback)
    },
}

export default ServiceOtherRegisterController
